/**
 * @description: 面包屑组件
 * @author: barry@jwis.cn
 * @param {routes|Array} 数据
 * @插槽
 * @slot {'after'|String} 插槽
 * @eg:
 *   [
 *     {
 *       path: 'index',
 *       name: 'home',
 *       icon: 'home'
 *     },
 *     {
 *       path: 'first',
 *       name: 'first',
 *       children: [
 *         {
 *           path: '/layout',
 *           name: 'Layout',
 *         }
 *       ],
 *     }
 *   ]
 */
<template>
  <div class="padding-y-15">
    <a-breadcrumb :routes="routes" class="flex-item">
      <a-icon type="caret-right" slot="separator" />
      <template slot="itemRender" slot-scope="{route}">
        <router-link v-if="!!route.path" :to="route.path">
          <a-icon v-if="route.icon" :type="route.icon" />
          {{toLowerCase(route.name)}}
        </router-link>
        <span v-else>
          {{toLowerCase(route.name)}}
        </span>
      </template>
    </a-breadcrumb>

    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  props: {
    routes: {
      type: Array,
      default: function () {
        return []
      }
    }
  },

  methods: {
    toLowerCase (name) {
      return name.toLowerCase()
    }
  }
}
</script>
